// Silk Road — client character data (with portraits). Generated by create-mod.
import { CHARACTERS_DATA, getCharacterById, getStartingMoney } from './characters-data';

const PORTRAIT_MAP = {

};

export const CHARACTERS = CHARACTERS_DATA.map(char => ({
  ...char,
  portrait: PORTRAIT_MAP[char.id] || null,
}));

export { getCharacterById, getStartingMoney };
